var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDdxExamplePrompts(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2031_41159)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.5625 11V15.125",
    stroke: "#4B4AD5",
    strokeWidth: 1.375,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.5 13.0625H20.625",
    stroke: "#4B4AD5",
    strokeWidth: 1.375,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.875 3.4375V7.5625",
    stroke: "#4B4AD5",
    strokeWidth: 1.375,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.8125 5.5H8.9375",
    stroke: "#4B4AD5",
    strokeWidth: 1.375,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.4375 15.8125V18.5625",
    stroke: "#4B4AD5",
    strokeWidth: 1.375,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.0625 17.1875H15.8125",
    stroke: "#4B4AD5",
    strokeWidth: 1.375,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.375 6.875L15.125 9.625",
    stroke: "#4B4AD5",
    strokeWidth: 1.375,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.6108 3.63921L3.63848 15.6115C3.36999 15.88 3.36999 16.3153 3.63848 16.5838L5.41591 18.3612C5.6844 18.6297 6.1197 18.6297 6.38819 18.3612L18.3605 6.38892C18.629 6.12043 18.629 5.68513 18.3605 5.41664L16.5831 3.63921C16.3146 3.37072 15.8793 3.37072 15.6108 3.63921Z",
    stroke: "#4B4AD5",
    strokeWidth: 1.375,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2031_41159"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 22,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDdxExamplePrompts);
export default __webpack_public_path__ + "static/media/ddx-example-prompts.b25f797fe9628f207759ea64d2f28796.svg";
export { ForwardRef as ReactComponent };